<table>
    <tr>
        <td>Flight Details: {{ orderShuttleVM.arrivalVM.arrivalCode }}&nbsp;{{
            orderShuttleVM.arrivalVM.departureStation }}&nbsp;{{ orderShuttleVM.arrivalVM.terminalName }}</td>
        <td>Status: {{ orderShuttleVM.arrivalVM.status }}</td>
        <td>Scheduled: {{ orderShuttleVM.arrivalVM.scheduledArrival | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td>Estimated: {{ orderShuttleVM.arrivalVM.estimatedArrival | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td>Actual: {{ orderShuttleVM.arrivalVM.actualArrival | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td>Gate: {{ orderShuttleVM.arrivalVM.gate}}</td>
        <td>Baggage: {{ orderShuttleVM.baggage ? 'Yes' : 'No' }}</td>
        <td>{{ orderShuttleVM.arrivalVM.remarks }}</td>
        <td>Claim Unit: {{ orderShuttleVM.arrivalVM.baggageClaimUnit }}</td>
        <td>First Bag: {{ orderShuttleVM.arrivalVM.firstBag | date: 'HH:mm' }}</td>
        <td>Last Bag: {{ orderShuttleVM.arrivalVM.lastBag | date: 'HH:mm' }}</td>
    </tr>
</table>